export const NUMBER_OF_CLUSTERS_TAG = 'num_clusters';
export const CLUSTERING_ALGORITHM_TAG = 'clustering_algorithm';
export const WINING_CLUSTERING_ALGORITHM_TAG = 'winning_clustering_algorithm';
export const WINING_NUMBER_OF_CLUSTERS_TAG = 'winning_num_clusters';
export const SCORE_COLUMN = 'Score Column';

export const PROJECT_VISUAL_TAGS_LABELS = {
    'Calibrate Result': 'Calibrate Result',
    'Confident based filtering': 'Confident based filtering',
    'Clustering': 'Clustering',
    'Number of retrieved results': 'Number of retrieved results',
    'Model Selection Metric': 'Model Selection Metric',
    'Model Selection Metric Threshold': 'Model Selection Metric Threshold',
    'clustering_fingerprint': 'Compound Representation',
    'clustering_algorithm': 'Clustering Algorithm',
    'num_clusters': 'Number of clusters',
    'Chemical Space Visualization': 'Chemical Space Visualization',
    'Clustering Evaluation': 'Clustering Evaluation',
    'SMILES Column': 'SMILES Column',
    'Score Column': 'Score Column',
    'Target Name': 'Target Name',
}